// extracted by mini-css-extract-plugin
module.exports = {"body_main_news":"Base_body_main_news__1texH","wrapper":"Base_wrapper__2UzYY","errorPage":"Base_errorPage__1ZfGc"};